import { Component, OnInit, Input, OnChanges, SimpleChange, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import {Warehouse, Warehouse3} from '../../project/warehouse';
import * as d3 from 'd3';


@Component({
  selector: 'app-frame3',
  templateUrl: './frames.component.html'
})
export class Frame3Component implements OnInit, OnChanges, AfterViewInit, HostListener {

  margin = {top: 20, right: 20, bottom: 20, left: 20};
  width: number;
  height: number;
  svg: any;
  data: any;
  origin: any;
  @Input() warehouse: Warehouse3;
  @Input() isChanged: boolean;
  height_r: number;
  factor: number;
  isInit: boolean;
  hb_additional_height: number;
  fontsize = "13px";
  radio = 7;
  el: ElementRef;
  @Input() inputFocus: string;
  div: string;

  constructor(el: ElementRef) {
    this.el = el;
    this.div = "#frame";
  }

  ngOnInit() {
    this.width = 400 - this.margin.left - this.margin.right;
    this.height = 400 - this.margin.top - this.margin.bottom;
    this.initFrame();
    this.isInit = true;
  }

  ngOnChanges(changes: {[propKey: string]: SimpleChange}){
    if(this.isInit){
      this.initFrame();
    }
  }

  initFrame(){
    this.prepareData();
    this.createFrame();
    this.addArc();
    this.addText();
    this.drawFocus();
  }

  ngAfterViewInit(): void {
      this.reDraw();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event){
    this.ngOnInit();
    this.reDraw();
  }

  reDraw(){
    const width = this.el.nativeElement.querySelector(this.div).offsetWidth;
    const height = this.el.nativeElement.querySelector(this.div).offsetHeight;
    this.width = width - this.margin.left - this.margin.right;
    this.height = height - this.margin.top - this.margin.bottom;
    this.initFrame();
  }

  prepareData(){

    const column_height = this.warehouse.column_height ? this.warehouse.column_height : 2000;
    const width_1 = this.warehouse.width_1 ? this.warehouse.width_1 : 1500;
    const slope_1 = this.warehouse.slope_1 ? this.warehouse.slope_1/100 : 1;
    const total_height = column_height+width_1*slope_1
    const width_2 = this.warehouse.width_2 ? this.warehouse.width_2 : 1500;
    const total_width = width_1+width_2
    const slope_2 = this.warehouse.slope_2 ? this.warehouse.slope_2/100 : 1;
    let has_door = this.warehouse.opening_height > 0 && this.warehouse.opening_width > 0 ? true : false;
    let opening_width = this.warehouse.opening_width ? this.warehouse.opening_width : 0;
    let opening_height = this.warehouse.opening_height ? this.warehouse.opening_height : 0;
    let hb_additional_height = this.warehouse.hb_additional_height ? this.warehouse.hb_additional_height : 0;

    this.height_r = column_height+slope_1*width_1-slope_2*width_2;
    const column_distance = this.warehouse.column_distance ? this.warehouse.column_distance: 2500;
    const height_c = column_distance < width_1 ?
          column_height + slope_1*column_distance :
          this.height_r + slope_2*(width_1+width_2-column_distance);

    if(total_height/this.height > total_width/this.width){
      this.factor = 1/(total_height/(this.height-this.margin.top-this.margin.bottom) );
      this.origin = [(this.width-total_width*this.factor)/2, this.height-this.margin.bottom];
    } else {
      this.factor = 1/(total_width/(this.width-this.margin.left-this.margin.right) );
      this.origin = [this.margin.right, (this.height+total_height*this.factor)/2];
    }


    this.data = {};
    this.data["height_l"] = column_height*this.factor;
    this.data["height_r"] = this.height_r*this.factor ;
    this.data["slope_l"] = slope_1;
    this.data["slope_r"] = slope_2;
    this.data["width_l"] = width_1*this.factor;
    this.data["width_r"] = width_2*this.factor;
    this.data["column_distance"] = column_distance*this.factor;
    this.data["height_c"] = height_c*this.factor;
    this.data["has_door"] = has_door;
    this.data["opening_width"] = opening_width*this.factor;
    this.data["opening_height"] = opening_height*this.factor;
    this.data["factor"] = this.factor;
    this.data["hb_additional_height"] = hb_additional_height*this.factor;
  }

  createFrame(){
    d3.select(this.div+" svg").remove();
    this.svg = d3.select(this.div)
      .append('svg')
      .style("position","relative")
      .style("left", "50%")
      .style("-webkit-transform", "translateX(-50%)")
      .style("-ms-transform", "translateX(-50%)")
      .style("transform", "translateX(-50%)")
      .attr('width', this.width + this.margin.left + this.margin.right)
      .attr('height', this.height + this.margin.top + this.margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top + ')');

    let l1 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "line l1")
      .attr("x1", this.origin[0])
      .attr("y1", this.origin[1])
      .attr("x2", this.origin[0])
      .attr("y2", this.origin[1]-this.data.height_l);

    let l2 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "line l2")
      .attr("x1", this.origin[0])
      .attr("y1", this.origin[1]-this.data.height_l)
      .attr("x2", this.origin[0]+this.data.width_l/2)
      .attr("y2", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l/2);

    let l3 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "line l3")
      .attr("x1", this.origin[0]+this.data.width_l/2)
      .attr("y1", this.origin[1]-this.data.height_l-this.data.slope_l*this.data.width_l/2)
      .attr("x2", this.origin[0]+this.data.width_l)
      .attr("y2", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l);

    let l4 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "line l4")
      .attr("x1", this.origin[0]+this.data.width_l)
      .attr("y1", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l)
      .attr("x2", this.origin[0]+this.data.column_distance)
      .attr("y2", this.origin[1]-this.data.height_c);
      // .attr("y2", this.origin[1]-this.data.height_l-this.data.width_l*this.data.slope_l+(this.data.column_distance-this.data.width_l)*this.data.slope_r );

    let l5 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "line l5")
      .attr("x1", this.origin[0]+this.data.column_distance)
      .attr("y1", this.origin[1]-this.data.height_c)
      // .attr("y1", this.origin[1]-this.data.height_l-this.data.width_l*this.data.slope_l+(this.data.column_distance-this.data.width_l)*this.data.slope_r )
      .attr("x2", this.origin[0]+this.data.column_distance+(this.data.width_l+this.data.width_r-this.data.column_distance)/2)
      .attr("y2", this.origin[1]-this.data.height_l-this.data.width_l*this.data.slope_l+(this.data.column_distance-this.data.width_l)*this.data.slope_r+(this.data.width_l+this.data.width_r-this.data.column_distance)/2*this.data.slope_r);

    let l6 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "line l6")
      .attr("x1", this.origin[0]+this.data.column_distance+(this.data.width_l+this.data.width_r-this.data.column_distance)/2)
      .attr("y1", this.origin[1]-this.data.height_l-this.data.width_l*this.data.slope_l+(this.data.column_distance-this.data.width_l)*this.data.slope_r+(this.data.width_l+this.data.width_r-this.data.column_distance)/2*this.data.slope_r)
      .attr("x2", this.origin[0]+this.data.width_l+this.data.width_r)
      .attr("y2", this.origin[1]-this.data.height_r);


    let l7 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "line l7")
      .attr("x1", this.origin[0]+this.data.width_l+this.data.width_r)
      .attr("y1", this.origin[1])
      .attr("x2", this.origin[0]+this.data.width_l+this.data.width_r)
      .attr("y2", this.origin[1]-this.data.height_r);

    let l8 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "line l8")
      .attr("x1", this.origin[0]+this.data.column_distance)
      .attr("y1", this.origin[1] - this.data.height_c)
      .attr("x2", this.origin[0]+this.data.column_distance)
      .attr("y2", this.origin[1]);


    let circle1 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0])
      .attr("cy", this.origin[1])
      .attr("r", this.radio);
    let circle2 = this.svg.append("circle")
    .style("fill", "#77768d")
      .attr("cx", this.origin[0])
      .attr("cy", this.origin[1]-this.data.height_l)
      .attr("r", this.radio);
    let circle3 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0]+this.data.width_l/2)
      .attr("cy", this.origin[1]-this.data.height_l-this.data.slope_l*this.data.width_l/2)
      .attr("r", this.radio);

    let circle4 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0]+this.data.width_l)
      .attr("cy", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l)
      .attr("r", this.radio);

    let circle5 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0]+this.data.column_distance+(this.data.width_l+this.data.width_r-this.data.column_distance)/2)
      .attr("cy", this.origin[1]-this.data.height_l-this.data.width_l*this.data.slope_l+(this.data.column_distance-this.data.width_l)*this.data.slope_r+(this.data.width_l+this.data.width_r-this.data.column_distance)/2*this.data.slope_r)
      .attr("r", this.radio);


    let circle6 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0]+this.data.width_l+this.data.width_r)
      .attr("cy", this.origin[1]-this.data.height_r)
      .attr("r", this.radio);

    let circle7 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0]+this.data.width_l+this.data.width_r)
      .attr("cy", this.origin[1])
      .attr("r", this.radio);

    let circle8 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0]+this.data.column_distance)
      .attr("cy", this.origin[1])
      .attr("r", this.radio);
    let circle9 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0]+this.data.column_distance)
      .attr("cy", this.origin[1] - this.data.height_c)
      .attr("r", this.radio);
  }


  addArc(){

    let arc1 = d3.arc()
        .innerRadius(this.radio*4-2)
        .outerRadius(this.radio*4)
        .startAngle(Math.PI/2-Math.atan(this.data.slope_l) )
        .endAngle(Math.PI/2);
    let slope_l = this.svg.append("path")
        .style("fill", "#77768d")
        .attr("class", "arc")
        .attr("d", arc1)
        .attr("transform", "translate("+this.origin[0]+", "+(this.origin[1]-this.data.height_l)+")");
    let arc2 = d3.arc()
        .innerRadius(this.radio*4-2)
        .outerRadius(this.radio*4)
        .startAngle(3*Math.PI/2+Math.atan(this.data.slope_r) )
        .endAngle(3*Math.PI/2);
    let slope_r = this.svg.append("path")
        .style("fill", "#77768d")
        .attr("class", "arc")
        .attr("d", arc2)
        .attr("transform", "translate("+(this.origin[0]+this.data.width_l+this.data.width_r)+", "+(this.origin[1]-this.data.height_r)+")");
    let arc1_l = this.svg.append("line")
        .style("stroke", "#77768d")
        .style("stroke-width", 2)
        .attr("x1", this.origin[0]+this.radio)
        .attr("y1", this.origin[1]-this.data.height_l)
        .attr("x2", this.origin[0]+this.radio*4)
        .attr("y2", this.origin[1]-this.data.height_l);
    let arc1_r = this.svg.append("line")
        .style("stroke", "#77768d")
        .style("stroke-width", 2)
        .attr("x1", this.origin[0]+this.data.width_l+this.data.width_r-this.radio)
        .attr("y1", this.origin[1]-this.data.height_r)
        .attr("x2", this.origin[0]+this.data.width_l+this.data.width_r-this.radio*4)
        .attr("y2", this.origin[1]-this.data.height_r);

  }

  addText(){
    let l1 = this.svg.append("text")
      .text((this.data.height_l/this.factor/1000).toFixed(2)+"[mt]")
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "middle")
      .attr("transform", "translate("+(this.origin[0]-15/2)+","+(this.origin[1]-this.data.height_l/2)+") rotate(-90)");

    let l2 = this.svg.append("text")
      .text(((this.data.width_l/this.factor/(Math.cos(Math.atan(this.data.slope_l))))/1000).toFixed(2)+"[mt]")
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "middle")
      .attr("transform", "translate("+(this.origin[0]+this.data.width_l/2)+","+(this.origin[1]-this.data.height_l-this.data.slope_l*this.data.width_l/2-15/2)+") rotate("+(-1*Math.atan(this.data.slope_l)*180/Math.PI)+")");

    let l3 = this.svg.append("text")
      .text(((this.data.width_r/this.factor/Math.cos(Math.atan(this.data.slope_r)))/1000).toFixed(2)+"[mt]")
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "middle")
      .attr("transform", "translate("+(this.origin[0]+this.data.width_l+this.data.width_r/2)+","+(this.origin[1]-this.data.height_r-this.data.slope_r*this.data.width_r/2-15/2)+") rotate("+((Math.atan(this.data.slope_r))*180/Math.PI)+")");

    let l4 = this.svg.append("text")
      .text((this.height_r/1000).toFixed(2)+"[mt]")
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "middle")
      .attr("transform", "translate("+(this.origin[0]+this.data.width_l+this.data.width_r+15)+","+(this.origin[1]-this.data.height_r/2)+") rotate(-90)");

    let l5 = this.svg.append("text")
      .text(((this.data.height_c/this.factor)/1000).toFixed(2)+"[mt]")
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "middle")
      .attr("transform", "translate("+(this.origin[0]+this.data.column_distance-15/2)+","+(this.origin[1] - this.data.height_c/2)+") rotate(-90)");

    let slope_l_background = this.svg.append("text")
      .text((this.data.slope_l).toFixed(2))
      .attr("font-size", this.fontsize)
      .attr("stroke", "rgba(255, 255, 255, 0.85)")
      .attr("stroke-width", "0.3em")
      .attr("text-anchor", "start")
      .attr("transform", "translate("+(this.origin[0]+this.radio*4+2)+","+(this.origin[1]-this.data.height_l)+")");

    let slope_l = this.svg.append("text")
      .text((this.data.slope_l).toFixed(2))
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "start")
      .attr("transform", "translate("+(this.origin[0]+this.radio*4+2)+","+(this.origin[1]-this.data.height_l)+")");

    let slope_r_background = this.svg.append("text")
      .text((this.data.slope_r).toFixed(2))
      .attr("font-size", this.fontsize)
      .attr("stroke", "rgba(255, 255, 255, 0.85)")
      .attr("stroke-width", "0.3em")
      .attr("text-anchor", "end")
      .attr("transform", "translate("+(this.origin[0]+this.data.width_l+this.data.width_r-this.radio*4-2)+","+(this.origin[1]-this.data.height_r)+")");

    let slope_r = this.svg.append("text")
      .text((this.data.slope_r).toFixed(2))
      .attr("font-size", this.fontsize)
      .attr("fill", "#77768d")
      .attr("text-anchor", "end")
      .attr("transform", "translate("+(this.origin[0]+this.data.width_l+this.data.width_r-this.radio*4-2)+","+(this.origin[1]-this.data.height_r)+")");

    if(!this.warehouse.column_height){
      l1.text(" -- [mt]");
    }
    if(!this.warehouse.width_1 || !this.warehouse.slope_1){
      l2.text(" -- [mt]");
    }
    if(!this.warehouse.slope_1){
      slope_l.text(" -- ");
      slope_l_background.text(" -- ");
    }
    if(!this.warehouse.width_2 || !this.warehouse.slope_2){
      l3.text(" -- [mt]");
    }
    if(!this.warehouse.slope_2){
      slope_r.text(" -- ");
      slope_r_background.text(" -- ");
    }
    if(!this.warehouse.column_height || !this.warehouse.width_1 || !this.warehouse.slope_1 || !this.warehouse.width_2 || !this.warehouse.slope_2){
      l4.text(" -- [mt]");
    }
    if(!this.warehouse.column_height || !this.warehouse.column_distance ||
      (this.warehouse.column_distance <= this.warehouse.width_1 && (!this.warehouse.width_1 || !this.warehouse.slope_1) ) ||
      (this.warehouse.column_distance > this.warehouse.width_1 && (!this.warehouse.width_2 || !this.warehouse.slope_2 || !this.warehouse.width_1 || !this.warehouse.slope_1) ) ){
        l5.text(" -- [mt]");
    }

  }

  drawFocus(){
    let focus = this.svg.append("line")
                .style("stroke", "#000")
                .style("stroke-width", 1);
    let f1 = this.svg.append("line")
                .style("stroke", "#000")
                .style("stroke-width", 1);
    let f2 = this.svg.append("line")
                .style("stroke", "#000")
                .style("stroke-width", 1);

    if(this.inputFocus == "column_height"){
      focus
        .attr("x1", this.origin[0]-25)
        .attr("y1", this.origin[1])
        .attr("x2", this.origin[0]-25)
        .attr("y2", this.origin[1]-this.data.height_l);
      f1
        .attr("x1", this.origin[0]-25-5)
        .attr("y1", this.origin[1])
        .attr("x2", this.origin[0]-25+5)
        .attr("y2", this.origin[1]);
      f2
        .attr("x1", this.origin[0]-25-5)
        .attr("y1", this.origin[1]-this.data.height_l)
        .attr("x2", this.origin[0]-25+5)
        .attr("y2", this.origin[1]-this.data.height_l);
    } else if(this.inputFocus == "width_1"){
      focus
        .attr("x1", this.origin[0])
        .attr("y1", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25)
        .attr("x2", this.origin[0]+this.data.width_l)
        .attr("y2", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25);
      f1
        .attr("x1", this.origin[0])
        .attr("y1", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25-5)
        .attr("x2", this.origin[0])
        .attr("y2", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25+5);
      f2
        .attr("x1", this.origin[0]+this.data.width_l)
        .attr("y1", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25-5)
        .attr("x2", this.origin[0]+this.data.width_l)
        .attr("y2", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25+5);
    } else if(this.inputFocus == "width_2"){
      focus
        .attr("x1", this.origin[0]+this.data.width_l)
        .attr("y1", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25)
        .attr("x2", this.origin[0]+this.data.width_l+this.data.width_r)
        .attr("y2", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25);
      f1
        .attr("x1", this.origin[0]+this.data.width_l)
        .attr("y1", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25-5)
        .attr("x2", this.origin[0]+this.data.width_l)
        .attr("y2", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25+5);
      f2
        .attr("x1", this.origin[0]+this.data.width_l+this.data.width_r)
        .attr("y1", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25-5)
        .attr("x2", this.origin[0]+this.data.width_l+this.data.width_r)
        .attr("y2", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25+5);
    } else if(this.inputFocus == "slope_1"){

      let slope_l = this.svg.append("text")
        .text((this.data.slope_l).toFixed(2))
        .attr("font-size", this.fontsize)
        .attr("stroke-width", "0.075em")
        .attr("stroke", "#000")
        .attr("fill", "#77768d")
        .attr("text-anchor", "start")
        .attr("transform", "translate("+(this.origin[0]+this.radio*4+2)+","+(this.origin[1]-this.data.height_l)+")");

      if(!this.warehouse.slope_1){
        slope_l.text(" -- ");
      }

    } else if(this.inputFocus == "slope_2"){

      let slope_r = this.svg.append("text")
        .text((this.data.slope_r).toFixed(2))
        .attr("font-size", this.fontsize)
        .attr("stroke-width", "0.075em")
        .attr("stroke", "#000")
        .attr("fill", "#77768d")
        .attr("text-anchor", "end")
        .attr("transform", "translate("+(this.origin[0]+this.data.width_l+this.data.width_r-this.radio*4-2)+","+(this.origin[1]-this.data.height_r)+")");

      if(!this.warehouse.slope_2){
        slope_r.text(" -- ");
      }

    } else if(this.inputFocus == "column_distance"){
      focus
        .attr("x1", this.origin[0])
        .attr("y1", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25)
        .attr("x2", this.origin[0]+this.data.column_distance)
        .attr("y2", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25);
      f1
      .attr("x1", this.origin[0])
      .attr("y1", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25-5)
      .attr("x2", this.origin[0])
      .attr("y2", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25+5);
      f2
      .attr("x1", this.origin[0]+this.data.column_distance)
      .attr("y1", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25-5)
      .attr("x2", this.origin[0]+this.data.column_distance)
      .attr("y2", (this.origin[1]-this.data.height_l)-this.data.slope_l*this.data.width_l-25+5);
    }


  }


}



// WEBPACK FOOTER //
// ./src/app/sketch/frames/frame3.component.ts